import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { PATHS } from '../../utils/urls';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="page-integrations" ontouchstart>
            <SEO title="Integrations | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Connect your People systems into one central hub. Automatically update your org chart, map and more. Finally, understand your org like never before."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Integrations | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Connect your People systems into one central hub. Automatically update your org chart, map and more. Finally, understand your org like never before." />
                <meta property="og:image" content={`https://www.charthop.com/integrations/integrations.gif`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Integrations | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Connect your People systems into one central hub. Automatically update your org chart, map and more. Finally, understand your org like never before." />
                <meta name="twitter:image" content={`https://www.charthop.com/integrations/integrations.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="sectionSpacing">
                <section className="hero-splitSectionSpacing contentBlock">
                    <div>
                        <div className="segmentHalf">
                            <div>
                              <h1 className="mx-auto">You don't need another platform.</h1>
                            </div>

                        </div>
                        <div className="segmentHalf">
                            <div className="reactPlayerContainer" >

                                <ReactPlayer
                                    url="/integrations/integration-hero.mp4"

                                    playing
                                    loop
                                    muted
                                    playsinline
                                />

                            </div>
                        </div>
                    </div>
                </section>
            </section>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
            <h2 className="text-center mt-0 sectionSpacing-Margin">You need one that brings them all together.</h2>               
               
                <div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
						<div className="svg-info-card-3col">
							<img src={'/integrations/update.svg'} alt="Update" />
							<h3>Update <span role="img" aria-label="sparkle">✨</span>automagically</h3>
							<p> Watch your Org Chart, Map, Reports and even Excel & Sheets update as your team changes - no manual work needed.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/integrations/workflow.svg'} alt="Workflow" />
							<h3>Automate workflows</h3>
							<p>As your plans and team change, automatically open new roles in your ATS, change distribution list membership and more! </p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/integrations/combine.svg'} alt="Combine" />
							<h3>Say goodbye to vlookups</h3>
							<p>Combine data from every source. Understand and visualize how everything fits together, without spreadsheet gymnastics.</p>
						</div>
					</div>
				</div>
                <div className="favouriteIntegrationsContent sectionSpacing">
                <h4 className="text-center mt-0 sectionSpacing-Margin">All of your people data - all in one place.</h4>
                    <div className="floating-majorCardContainer">
                        <div>
                            <div>
                                    {/* TOP 3 */}
                                <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                            <p>Automagically create and update your Org Chart, Map, Data Sheets, and Reports using your HRIS data.</p>
                            <p className="mb-0"><a href={PATHS.BAMBOOHR} className="ctaStandard">Learn more</a></p>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logo-sapling.png' alt="Sapling" />
                            </div>
                            <p>Understand compensation by individuals or groups and propose future compensation changes.</p>
                            <p>Plus, identify pay parity issues.</p>
                            <p className="mb-0"><a href={PATHS.SAPLING} className="ctaStandard">Learn more</a></p>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                            <p>Automagically create and update your Org Chart, Map, Data Sheets, and Reports using your HRIS data.</p>
                            <p className="mb-0"><a href={PATHS.WORKDAY} className="ctaStandard">Learn more</a></p>
                        </div>
                            {/* TOP 6 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                            <p>Automagically create and update your Org Chart, Map, Data Sheets, and Reports using your HRIS data.</p>
                            <p className="mb-0"><a href={PATHS.SAP_SUCCESSFACTORS} className="ctaStandard">Learn more</a></p>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                            <p>Plan and manage your headcount growth from ChartHop. Always know which roles are open, hired and filled. </p>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                            <p>Understand full compensation for every employee in one place. </p>
                        </div>
                        {/* TOP 9 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack" />
                            </div>
                            <p>Sync profile pictures, enable quick communication from the org chart and to send out notifications.</p>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-gsuite.png' alt="G suite" />
                            </div>
                            <p>Create new G suite profiles for new hires and manage distribution lists membership.</p>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-okta.png' alt="Okta" />
                            </div>
                            <p>Securely sign in to ChartHop and manage employee access based on their role.</p>
                        </div>
                    </div>
                </div>



                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        {/* FIRST 4 */}

                        <div>
                            <div>
                            <a href={PATHS.TRINET}><img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" /></a>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <a href={PATHS.ZENEFITS}><img src='/integrations/logos/zenefits.png' alt="Zenefits" /></a>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* SECOND 4 */}
                        <div>
                            <div>
                            <a href={PATHS.GUSTO}><img src='/integrations/logos/gusto.png' alt="Gusto" /></a>
                            </div>
                        </div>
                        <div>
                            <div>
                            <a href={PATHS.JUSTWORKS}><img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" /></a>
                            </div>
                        </div>
                        <div>
                            <div>
                            <a href={PATHS.PAYLOCITY}><img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" /></a>
                            </div>
                        </div>
                        <div>
                            <div>
                            <a href={PATHS.NAMELY}><img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" /></a>
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-activedirectory@2x.jpg' alt="Microsoft Active Directory" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <a href={PATHS.RIPPLING}><img src='/integrations/logos/logo-rippling@2x.jpg' alt="Rippling" /></a>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-googlesso@2x.jpg' alt="Google SSO" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-microsoftsso@2x.jpg' alt="Microsoft SSO" />
                            </div>
                        </div>

                        {/* FOURTH 4 */}
                        <div className="psudeo ps4">
                        </div>
                        <div>
                            <div>
                            <a href={PATHS.HUMAANS}><img src='/integrations/logos/logo-humaans@2x.png' alt="Humaans" /></a>
                            </div>
                        </div>
                        <div>
                            <div>
                            <a href={PATHS.SEQUOIA}><img src='/integrations/logos/logo-sequoia@2x.png' alt="Sequoia" /></a>
                            </div>
                        </div>
                        <div className="psudeo ps4">
                        </div>

                        {/* <div> */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">
                        </div>
                        {/* </div> */}
                        <h4 className="text-center">& many more</h4>
                    </div>
                </div>
            </section>
            

            {/* LONG FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"product-integrations-demo-bottom"} headertext={HtmlParser("<h2>See it in action!</br></br> Request a demo now.</h2>")} focusID={HtmlParser("name")} />
            </section>
        </Layout>
    );
};


export default Home;
